import { inject } from "@angular/core";
import { Tool } from "@aws-sdk/client-bedrock-runtime";
import { AITool } from "../../../03_model/ai-tool.interface";
import { AIComponentMessage, AIToolResponseMessage } from "../../../03_model/ai-chat-message.model";
import { OrderSearchResultMessageComponent } from "../messages/order-search-result-message/order-search-result-message.component";
import { I18n } from "@corporate/ng-tebis-base-components";

export class DisplayOrdersTool implements AITool {

  i18n = inject(I18n);

  tool_name = 'display_orders';

  description = <Tool>{
    "toolSpec": {
      "name": this.tool_name,
      "description": "Display orders as card list to the user by providing a list of orderIDs.",
      "inputSchema": {
        "json": {
          "type": "object",
          "properties": {
            "textMessage": {
              "type": "string",
              "description": "A free text message to provide context for the displayed orders, e.g. 'Here are the orders that match your search criteria:'."
            },
            "orderIDs": {
              "type": "array",
              "items": {
                "type": "string"
              },
              "description": "A list of manufacturing order IDs to display to the user."
            }
          },
          "required": [
            "orderIDs"
          ]
        }
      }
    }
  };

  async invoke({orderIDs, textMessage}: {orderIDs?: string[], textMessage?: string}): Promise<AIComponentMessage | AIToolResponseMessage> {
    if (!orderIDs || orderIDs.length === 0) {
      return {
        type: 'tool-response',
        role: 'user',
        content: `Tool result: No order IDs provided to display.`,
        requiresFollowUp: true,
      };
    }
    return {
      type: 'component',
      role: 'user',
      component: OrderSearchResultMessageComponent,
      data: {
        message: textMessage || '',
        orderIDs,
      },
      contentForLLM: `Tool result: Displaying ${orderIDs.length} manufacturing orders. Order IDs: ${orderIDs.join(', ')}.`,
      requiresFollowUp: false,
    };
  }
}
